import IMAPlayerManager from './ima/ima.player.manager';
import * as PlayerTypes from './constants/player.types';
import AdException from '../errors/ad.exception';
import DisplayPlayerManager from './display/display.player.manager';

/* eslint-disable no-undef */
export default class PlayerFactory {
  constructor(idComponent, cid, itemContent) {
    this.idComponent = idComponent;
    this.isMutedByVastConfiguration = false;
    this.cid = cid;
    this.itemContent = itemContent;
  }

  getType(typeVideo) {
    this.typeVideo = typeVideo;
    switch (typeVideo) {
      case PlayerTypes.IMA:
        return new IMAPlayerManager(this.idComponent, this.cid);
      case PlayerTypes.DISPLAY:
        return new DisplayPlayerManager(this.idComponent, this.cid, this.itemContent);
      default:
        throw new AdException(`[PlayerFactory] Type of url not found ${typeVideo}`);
    }
  }

  setVastManager(vastManager) {
    this.vastManager = vastManager;
  }
}
